import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M10.083 9A6.002 6.002 0 0 1 16 4a4.243 4.243 0 0 0 6 6c0 2.22-1.206 4.16-3 5.197",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 20v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 19v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CloudMoonRain";
const CloudMoonRain = memo(themed(Icon));
export {
  CloudMoonRain
};
//# sourceMappingURL=cloud-moon-rain.js.map
